import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import * as perm from '../../permission';

class PermissionWrapper extends React.Component {
  constructor(props, context) {
    super(props, context);
    // this.hasPermission = this.hasPermission.bind(this);
  }

  render() {
    if(perm.hasPermission(this.props.currentUser,
                          this.props.allowed,
                          this.props.object,
                          this.props.permissionType)) {
      return this.props.children;
    }
    return null;
  }
}

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
PermissionWrapper.propTypes = {
  currentUser: PropTypes.object,
  allowed: PropTypes.array.isRequired,
  object: PropTypes.object,
  permissionType: PropTypes.string,
  children: PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.array,
    React.PropTypes.element,
  ]),
};

function mapStateToProps(state) {
  return {
    currentUser: state.users.currentUser,
  };
}


export default connect(
  mapStateToProps,
  null
)(PermissionWrapper);



/** WEBPACK FOOTER **
 ** ./src/components/common/PermissionWrapper.js
 **/